export const listingCategories = [
  "Ukategoriseret",
  "Bolig",
  "Mobler",
  "Elektronik",
  "Fritid",
  "Tøj",
];

export const searchCategories = ["Alle", ...listingCategories.filter(
  (category) => category !== "Ukategoriseret"
)];

export function listingCategoryLabel(category) {
  return category === "Mobler" ? "Møbler" : category;
}
